import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'errorMessage'
})
export class ErrorMessagePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(errors: any, args?: any): string {
    if (!errors || Object.keys(errors).length === 0) {
      return '';
    }
    if (errors.matDatepickerParse) {
      return this.translate.instant('Error_InvalidDate');
    }
    if (errors.matDatepickerMin || errors.matDatepickerMax) {
      return this.translate.instant('Error_DateOutOfRange');
    }
    if (errors.invalidDevice) {
      return this.translate.instant('Error_NonExistentDevice');
    }
    if (errors.invalidAddress) {
      return this.translate.instant('Error_InvalidAddress');
    }
    if (errors.minSelected) {
      return this.translate.instant('Error_NoValues');
    }
    if (errors.email) {
      return this.translate.instant('Error_Email');
    }
    if (errors.required) { // should be the last one
      return this.translate.instant('Error_Required');
    }

    return this.translate.instant('Error_Unknown');
  }

}
